import { datadogRum } from '@datadog/browser-rum';

export function initDatadogRum() {
  if (process.env.NEXT_PUBLIC_NODE_ENV === 'development') return;

  try {
    datadogRum.init({
      applicationId: '71c8614a-72d2-429c-aa13-6a14835dc07e',
      clientToken: 'pub8e731efb9c43719198bba2628856f8c3',
      site: 'datadoghq.com',
      service: 'hotline',
      env: process.env.NEXT_PUBLIC_ENV,
      version: process.env.NEXT_PUBLIC_APP_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackBfcacheViews: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
  } catch (err) {
    console.error('Error initializing Datadog RUM:', err);
  }
}
